const _excluded = ["title", "disableArrow"],
  _excluded2 = ["customArrow", "arrowInner"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Tooltip as MuiTooltip, Grow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
import { PopoverArrowIcon } from "../PopoverArrowIcon";
const NoTransition = props => /*#__PURE__*/React.createElement(Grow, _extends({}, props, {
  timeout: 0
}));
const useStyles = makeStyles({
  tooltip: {
    fontFamily: typography.fontFamilyLight,
    fontSize: typography.fontSizeP1,
    color: colors.dark50,
    background: colors.dark900,
    padding: 12,
    borderRadius: 8,
    maxWidth: 'min(460px, 75vw)'
  },
  tooltipPlacementTop: {
    marginBottom: 12,
    '& $customArrow': {
      bottom: 4
    }
  },
  tooltipPlacementBottom: {
    marginTop: 12,
    '& $customArrow': {
      top: 4
    },
    '& $arrowInner': {
      transform: 'rotate(180deg)'
    }
  },
  tooltipPlacementLeft: {
    marginRight: 12,
    '& $customArrow': {
      right: -6
    },
    '& $arrowInner': {
      transform: 'rotate(270deg)'
    }
  },
  tooltipPlacementRight: {
    marginLeft: 12,
    '& $customArrow': {
      left: -6
    },
    '& $arrowInner': {
      transform: 'rotate(90deg)'
    }
  },
  customArrow: {
    position: 'absolute',
    width: 29,
    height: 9,
    color: colors.dark900
  },
  arrowInner: {
    position: 'absolute'
  }
});
export function Tooltip(props) {
  const {
      title,
      disableArrow
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [arrowRef, setArrowRef] = useState(null);
  const _useStyles = useStyles(),
    {
      customArrow,
      arrowInner
    } = _useStyles,
    restStyles = _objectWithoutProperties(_useStyles, _excluded2);
  return /*#__PURE__*/React.createElement(MuiTooltip, _extends({}, rest, {
    arrow: false,
    enterTouchDelay: 0,
    leaveTouchDelay: 3000,
    title: title && !disableArrow ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      ref: setArrowRef,
      className: customArrow
    }, /*#__PURE__*/React.createElement(PopoverArrowIcon, {
      className: arrowInner
    })), title) : title
    // Necessary because our custom arrow appears with a delay when there's a transition.
    ,
    TransitionComponent: NoTransition,
    PopperProps: {
      popperOptions: {
        modifiers: {
          arrow: disableArrow ? undefined : {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    },
    classes: restStyles
  }));
}